import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslationHandlerService } from '../localization/translation-handler.service';

// ✅ PrimeNG modules
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { OverlayModule } from 'primeng/overlay';
import { AccordionModule } from 'primeng/accordion';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DividerModule } from 'primeng/divider';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { SliderModule } from 'primeng/slider';
import { TooltipModule } from 'primeng/tooltip';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { TabsModule } from 'primeng/tabs';
import { ToastModule } from 'primeng/toast';
import { MultiSelectModule } from 'primeng/multiselect';
import { ChipModule } from 'primeng/chip';
import { DatePickerModule } from 'primeng/datepicker';
import { FileUploadModule } from 'primeng/fileupload';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DataViewModule } from 'primeng/dataview';
import { EditorModule } from 'primeng/editor';
import { ChartModule } from 'primeng/chart';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';

import { TextareaModule } from 'primeng/textarea';
import { TreeModule } from 'primeng/tree';

// ✅ Other libraries
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClipboardModule } from 'ngx-clipboard';
import { ColorPickerModule } from 'ngx-color-picker';
import { LinkyModule } from 'ngx-linky';

const modules = [
  CommonModule,
  FormsModule,
  ButtonModule,
  SelectModule,
  TableModule,
  OverlayModule,
  AccordionModule,
  DialogModule,
  ConfirmDialogModule,
  CheckboxModule,
  RadioButtonModule,
  ProgressSpinnerModule,
  InputTextModule,
  PasswordModule,
  SelectButtonModule,
  DividerModule,
  ToggleSwitchModule,
  SliderModule,
  TooltipModule,
  MenuModule,
  MenubarModule,
  TabsModule,
  ToastModule,
  MultiSelectModule,
  ChipModule,
  DatePickerModule,
  FileUploadModule,
  AutoCompleteModule,
  DataViewModule,
  EditorModule,
  ChartModule,
  DragDropModule,
  ClipboardModule,
  ColorPickerModule,
  LinkyModule,
  TranslateModule,
  InputNumberModule,
  InputGroupModule,
  InputGroupAddonModule,
  TabsModule,
  TreeModule,
];

@NgModule({
  imports: [TextareaModule, ...modules],
  exports: [TextareaModule, ...modules],
})
export class ThirdPartySharedModule {
  static forRoot(): ModuleWithProviders<ThirdPartySharedModule> {
    return {
      ngModule: ThirdPartySharedModule,
      providers: [{ provide: MissingTranslationHandler, useClass: TranslationHandlerService }],
    };
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
